export const testimonials = [
  {
    id: 1,
    content: "Turnaround was fast and the system just works. Our team productivity increased by 40%.",
    author: "Sarah Chen",
    role: "Operations Lead",
    company: "TechStart Inc."
  },
  {
    id: 2,
    content: "Dashboards saved us hours weekly. The real-time insights transformed our decision-making process.",
    author: "Michael Rodriguez",
    role: "Director",
    company: "Retail Solutions"
  },
  {
    id: 3,
    content: "Professional, reliable, and always available. Next Core delivered exactly what we needed.",
    author: "Jennifer Park",
    role: "IT Manager",
    company: "Public Services Group"
  }
];


